import { useQueryClient } from "@tanstack/react-query";
import { SettingsIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";
import {
  allUserSettingsQueryKey,
  useGetAllUserSettings,
} from "@/hooks/queries/useGetAllUserSettings";
import { useUpdateSetUserSettings } from "@/hooks/updateSets/useUpdateSetUserSettings";
import { RacetrackData } from "@/types";

export const LeaderboardSettingsPopover = () => {
  /* React Hooks */
  const queryClient = useQueryClient();
  const { data: racetrackData } = useGetAllUserSettings();
  const { mutate: updateUserSettings } = useUpdateSetUserSettings();

  const showRacetrack = racetrackData?.showRacetrack !== false;

  /* Cache Updates */
  const setShowRacetrack = (show: boolean) => {
    queryClient.setQueryData<RacetrackData>(allUserSettingsQueryKey, (prev) =>
      prev ? { ...prev, showRacetrack: show } : prev,
    );
    updateUserSettings({ showRacetrack: show });
  };

  /* Render */
  const render = () => (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="text-slate-700 [&_svg]:size-6"
        >
          <SettingsIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56">
        <Column className="gap-3">
          <Row className="items-center justify-between gap-3">
            <Text className="text-sm font-medium text-slate-700">
              Show racetrack
            </Text>
            <Switch
              checked={showRacetrack}
              onCheckedChange={setShowRacetrack}
            />
          </Row>
        </Column>
      </PopoverContent>
    </Popover>
  );

  return render();
};
